import { MDialog, TMDialogProps } from "src/ui/Dialog/MDialog"
import { BaseWizard } from "src/ui/Wizard/BaseWizard"
import { IDialogWizardStep } from "src/ui/Wizard/wizardTypes"

type TDialogWizardProps = Pick<
  TMDialogProps,
  "open" | "error" | "description" | "loading"
> & {
  steps: IDialogWizardStep[]
  currentStep: number
  onNext?: () => void
  onBack: () => void
}

export function DialogWizard({
  steps,
  open,
  onBack,
  onNext,
  currentStep,
  error,
  description,
  loading,
}: TDialogWizardProps) {
  return (
    <MDialog
      open={open}
      onClose={steps[currentStep]?.onBack ?? onBack}
      onConfirm={steps[currentStep]?.onNext ?? onNext}
      title={steps[currentStep]?.title}
      closeLabel={steps[currentStep]?.backButtonLabel}
      confirmLabel={steps[currentStep]?.nextButtonLabel}
      error={error}
      description={steps[currentStep]?.description ?? description}
      loading={steps[currentStep]?.loading ?? loading}
      confirmButtonProps={steps[currentStep]?.confirmButtonProps}
    >
      <BaseWizard currentStep={currentStep} steps={steps} hideButtonRow />
    </MDialog>
  )
}
